import { createContext } from "react";

/** True on pages whose global top bar, and its Ask Redo button, are hidden. */
export const GlobalTopBarHiddenContext = createContext(false);
